import { React, useState } from "react";
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaGithub } from "react-icons/fa";

const Footer = () => {
  const [submissionStatus, setSubmissionStatus] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    feedback: "",
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = {
      name: formData.name,
      email: formData.email,
      feedback: formData.feedback,
    };

    fetch(
      "https://script.google.com/macros/s/AKfycbzd4_eeM4FQmHWc_Vu3qn8giueh-4uOll8R_Z-AD7SlzKuTv3lK0cd6QVd66YvdS021/exec",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams(data).toString(),
      }
    )
      .then((response) => response.text())
      .then((response) => {
        setSubmissionStatus("success");
        setFormData({ name: "", email: "", feedback: "" });
      })
      .catch((error) => {
        setSubmissionStatus("success");
        setFormData({ name: "", email: "", feedback: "" });
      });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  return (
    <footer style={footerStyle}>
      <div style={sectionStyle}>
        <div style={columnStyle}>
          <h5 style={headingStyle}>About NIDS Project</h5>
          <p>
            NIDS is designed to safeguard networks by detecting and analyzing
            potential security threats in real-time.
          </p>
        </div>

        <div style={columnStyle}>
          <h5 style={headingStyle}>Project Information</h5>
          <p>
            <b>Project:</b> Network Intrusion Detection System (NIDS)
          </p>
          <p>
            <b>Report Author:</b> Rohith Pradeep
          </p>
          <p>
            <b>Email:</b> rohithpradeep001@gmail.com
          </p>
        </div>

        <div style={columnStyle}>
          <h5 style={headingStyle}>Feedback</h5>
          <form onSubmit={handleSubmit} style={formStyle}>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Enter Your Name"
              required
              style={inputStyle}
            />
            <input
              type="email"
              name="email"
              placeholder="Enter Your Email"
              value={formData.email}
              onChange={handleChange}
              required
              style={inputStyle}
            />
            <textarea
              rows="3"
              name="feedback"
              placeholder="Your Feedback"
              required
              value={formData.feedback}
              onChange={handleChange}
              style={textareaStyle}
            ></textarea>
            <button type="submit" style={buttonStyle}>
              Submit
            </button>
            {submissionStatus === "success" && (
              <span style={glowTextGreen}>Thank you for your feedback!</span>
            )}
            {submissionStatus === "error" && (
              <span style={glowTextRed}>
                Error submitting feedback. Please try again.
              </span>
            )}
          </form>
        </div>
      </div>

      <hr style={dividerStyle} />

     
      <div style={socialContainerStyle}>
        <a href="https://linkedin.com/in/rohith-pradeep" target='_blank' style={iconStyle} aria-label="LinkedIn">
          <FaLinkedinIn size={24} />
        </a>
        <a href="https://github.com/ROHITTTTZ" style={iconStyle} aria-label="GitHub">
          <FaGithub size={24} />
        </a>
      </div>
    </footer>
  );
};

export default Footer;

const footerStyle = {
  backgroundColor: "#3c0066",
  color: "white",
  padding: "2rem 1rem",
  textAlign: "center",
};

const sectionStyle = {
  display: "flex",
  justifyContent: "space-around",
  flexWrap: "wrap",
  marginBottom: "2rem",
};

const columnStyle = {
  flex: "1",
  textAlign: "start",
  margin: "0 1rem",
  maxWidth: "300px",
};

const headingStyle = {
  borderBottom: "2px solid #8b5cf6",
  paddingBottom: "0.5rem",
  marginBottom: "1rem",
  color: "#a78bfa",
};

const formStyle = {
  display: "flex",
  flexDirection: "column",
  alignItems: "start",
};

const inputStyle = {
  width: "100%",
  padding: "0.5rem",
  marginBottom: "1rem",
  borderRadius: "4px",
  border: "1px solid #ccc",
};

const textareaStyle = {
  width: "100%",
  padding: "0.5rem",
  marginBottom: "1rem",
  borderRadius: "4px",
  border: "1px solid #ccc",
};

const buttonStyle = {
  padding: "0.5rem 1rem",
  borderRadius: "4px",
  border: "none",
  backgroundColor: "#a78bfa",
  color: "#3c0066",
  cursor: "pointer",
};

const dividerStyle = {
  border: "1px solid #8b5cf6",
  margin: "2rem 0",
};

const socialContainerStyle = {
  display: "flex",
  justifyContent: "center",
  gap: "1rem",
  marginBottom: "1rem",
};

const iconStyle = {
  color: "white",
  textDecoration: "none",
};

const glowTextGreen = {
  color: "green",
  textShadow:
    "rgb(0 195 0) 0px 0px 1px, rgb(78 100 78) 0px 0px 1px, rgb(50, 205, 50) 0px 0px 1px, rgb(60 139 60) 0px 0px 1px",
  fontWeight: "bold",
};

const glowTextRed = {
  color: "red",
  textShadow:
    "rgb(0 195 0) 0px 0px 1px, rgb(78 100 78) 0px 0px 1px, rgb(50, 205, 50) 0px 0px 1px, rgb(60 139 60) 0px 0px 1px",
  fontWeight: "bold",
};
